import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var DEFAULT_AGENT = {
  id: 'ai_mate_agent',
  named_id: 'ai_mate_agent',
  name: 'AI Mate',
  description: 'AI Mate',
  creator_type: 'SYSTEM',
  available_plugins: {},
  is_default: true,
  visibility: 'PUBLIC'
};
export var DEFAULT_AGENTS_NAMED_ID_LIST = new Set(['decision_director_agent', 'user_manual_writer_agent', 'product_requirements_expert_agent']);
export var DEFAULT_OOTB_AGENTS_NAMED_IDS = _defineProperty(_defineProperty(_defineProperty({}, 'confluence', new Set(['decision_director_agent', 'product_requirements_expert_agent', 'rovo_expert_agent'])), 'jira', new Set(['rovo_expert_agent', 'issue_organizer_agent', 'jira_theme_analyzer_agent'])), 'atlas', new Set(['progress_tracker_agent', 'product_requirements_expert_agent', 'rovo_expert_agent']));
var AGENT_AUP_ERROR_CODE = "convoai.agent.responsible-ai.failure";
var HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
export var isCreateOrEditAgentAUPError = function isCreateOrEditAgentAUPError(error) {
  return Boolean(error) && _typeof(error) === 'object' && error.errorAttributes && error.errorAttributes.errorCode === AGENT_AUP_ERROR_CODE;
};
export var isHipaaError = function isHipaaError(error) {
  return Boolean(error) && _typeof(error) === 'object' && error.errorAttributes && error.errorAttributes.errorCode === HIPAA_ERROR_CODE;
};